import React from 'react';

import {connect} from "react-redux";
import FogTable from "./FogTable";
import Loader from "../common/Loader";
import * as fogActions from "../../actions/fog";
import {Button, Input} from "react-materialize";
import FogTabs from "./FogTabs";
import * as creationActions from "../../actions/creation";

class FogTableWrapper extends React.Component {
    componentDidMount() {
        if (this.props.displayAll === false) {
            setTimeout(this.props.dispatch(fogActions.fetchFogs(true)), 1000);
        } else {
            setTimeout(this.props.dispatch(fogActions.fetchFogs(true, true)), 1000);
        }
    }

    toggleButton(event, value) {
        this.props.dispatch(fogActions.setFogDisplayAllFilter(!event.target.checked));
    }

    render() {
        if (this.props.loading || this.props.fogs === undefined) {
            return (<div><Loader/></div>)
        }

        return (
            <div>
                <Button floating onClick={() => this.props.handleClick(FogTabs, null, creationActions.destroyingnewlyCreatedFog())} icon="add" className="add-button" />
                <FogTable {...this.props} data={this.props.fogs} />
                <Button floating onClick={() => this.props.handleClick(FogTabs, null, creationActions.destroyingnewlyCreatedFog())} icon="add" className="add-button" />
                <span style={{float: "right"}} ><Input type='switch' value={!this.props.displayAll} checked={!this.props.displayAll} onChange={this.toggleButton.bind(this)} offLabel={"All FOGS"} onLabel={"Active fogs"} /></span>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        fogs: state.fog.fogs,
        loading: state.fog.loading,
        displayAll: state.connect.displayAll,
        duplicating: state.fog.duplicating,
    });
})(FogTableWrapper);


// WEBPACK FOOTER //
// ./src/components/fog/FogTableWrapper.js